import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.techCounts, (element, index) => {
    return _openBlock(), _createBlock(_Teleport, {
      key: index,
      to: `#${_ctx.cmpId} [data-list-card-count='${element.value}']`
    }, [_createElementVNode("span", null, "(" + _toDisplayString(element.numberOfResults) + ")", 1)], 8, ["to"]);
  }), 128);
}